import { render, staticRenderFns } from "./KeyboardBox.vue?vue&type=template&id=710023fa&scoped=true&lang=pug&"
import script from "./KeyboardBox.vue?vue&type=script&lang=js&"
export * from "./KeyboardBox.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardBox.vue?vue&type=style&index=0&id=710023fa&scoped=true&lang=css&"
import style1 from "./KeyboardBox.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-5d68b12ba1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710023fa",
  null
  
)

export default component.exports